//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { formatToEuro } from 'src/util/filter';
import CampaignCard from 'components/advertising/details/CampaignCard';
import NumbersCard from 'components/analytics/NumbersCard';
import AnalyticsChartCard from 'components/analytics/AnalyticsChartCard';

export default {
	name: 'AdvertisingDetailPage',
	components: {
		CampaignCard,
		NumbersCard,
		AnalyticsChartCard,
	},
	data: () => ({
		loading: true,
		title: null,
	}),
	props: {
		id: {
			required: true,
		},
	},
	computed: {
		...mapState('advertising', ['campaign']),
		...mapState('advertising', [
			'campaignStatsData',
			'impressionSum',
			'impressionChart',
			'clickSum',
			'clickChart',
			'reachSum',
			'reachChart',
		]),
		chip() {
			if (!this.campaign || !this.campaign.id) return null;
			switch (this.campaign.status) {
				case -1:
					return {
						bgc: 'amber-1',
						fgc: 'amber-14',
						txt: 'Wird erstellt...',
					};
				case 1:
					return {
						bgc: 'green-1',
						fgc: 'green-14',
						txt: 'Aktiv',
					};
				default:
					return {
						bgc: 'grey-1',
						fgc: 'grey-14',
						txt: 'Beendet',
					};
			}
		},
		canShowStats() {
			return Object.keys(this.campaignStatsData).length > 0;
		},
		leads() {
			if (!this.canShowStats) return 0;
			const stat = this.campaignStatsData.actions.find(a => a.action_type === 'lead');
			const { value } = stat || 0;
			return parseInt(value || 0);
		},
		phoneClicks() {
			if (!this.canShowStats) return 0;
			const stat = this.campaignStatsData.actions.find(a => a.action_type === 'onsite_conversion.click_to_call');
			const { value } = stat || 0;
			return parseInt(value || 0);
		},
	},
	async created() {
		await this.$store.dispatch('advertising/getCampaign', this.id);
		this.loading = false;
	},
	methods: {
		formatToEuro,
		async updateCampaign() {
			await this.$store.dispatch('advertising/updateCampaign', {
				id: this.campaign.id,
				title: this.title,
			});
			this.title = null;
			await this.$store.dispatch('advertising/getCampaigns');
		},
	},
};
